import { Box, useStyleConfig } from "@chakra-ui/react";
import { ReactElement } from "react";

const BoxAccordionItem: React.FC<any> = (props:any) => {
    const { variant, ...rest } = props;

    const styles = useStyleConfig('BoxAccordionItem', { variant });

    return <Box __css={styles} {...rest} />
};

export default BoxAccordionItem;